export default "__VITE_ASSET__Uf10tIx$__"